import { a as __extends, d as __assign, _ as __makeTemplateObject } from '../../chunks/chunk-525a49bc.js';
import { Modal, Table, Icon } from 'antd';
import React from 'react';
import styled from 'styled-components';
import '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { d as defaultTheme, w as withDefaultTheme, c as withAssetEvents } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import 'moment';
import { a as momentFromTimestamp } from '../../chunks/chunk-06cde6d9.js';

var defaultRenderEventMetadata = function (event) { return (React.createElement(EventMetadataList, { key: "event-metadata" }, Object.keys(event.metadata || {}).map(function (key) { return (React.createElement("div", { key: key, className: "event-metadata" },
    React.createElement("strong", null, key),
    " ",
    React.createElement("br", null),
    React.createElement("span", null, event.metadata && event.metadata[key]))); }))); };
var AssetEventsPanelPureComponent = /** @class */ (function (_super) {
    __extends(AssetEventsPanelPureComponent, _super);
    function AssetEventsPanelPureComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderEventDetails = function (event) { return (React.createElement(EventDetails, { key: "event-detail" },
            React.createElement("div", { key: "event-type" },
                React.createElement("strong", null,
                    event.type,
                    ","),
                " ",
                event.subtype),
            event.description && (React.createElement("div", { className: "description" }, event.description)),
            React.createElement("div", { key: "event-time", className: "times" },
                React.createElement("span", null, event.start),
                React.createElement("span", null,
                    React.createElement(Icon, { type: "right" })),
                React.createElement("span", { style: { textAlign: 'right' } }, event.end)))); };
        _this.mapEvent = function (event) { return (__assign(__assign({}, event), { typeAndSubtype: (React.createElement("span", null,
                React.createElement("strong", { style: { display: 'block' } }, event.type),
                React.createElement("span", { style: { fontSize: 12, opacity: 0.8 } }, event.subtype))), description: event.description || 'No description', start: typeof event.startTime === 'number'
                ? momentFromTimestamp(event.startTime).format('LLL')
                : '-', end: typeof event.endTime === 'number'
                ? momentFromTimestamp(event.endTime).format('LLL')
                : 'Ongoing' })); };
        _this.onEventClick = function (id) {
            var assetEvents = _this.props.assetEvents;
            if (!assetEvents) {
                return;
            }
            var selectedEvent = assetEvents.find(function (e) { return e.id === id; });
            if (!selectedEvent) {
                return;
            }
            _this.setState({
                selectedEvent: _this.mapEvent(selectedEvent),
            });
        };
        _this.state = {
            selectedEvent: null,
        };
        return _this;
    }
    AssetEventsPanelPureComponent.prototype.getTableComponents = function () {
        var _this = this;
        var styles = this.props.styles;
        return {
            body: {
                row: function (props) {
                    return (React.createElement(StyledRow, { style: styles && styles.tableRow, onClick: function () { return _this.onEventClick(props['data-row-key']); } }, props.children));
                },
                cell: function (props) {
                    return (React.createElement(StyledCell, { style: styles && styles.tableCell }, props.children));
                },
            },
        };
    };
    AssetEventsPanelPureComponent.prototype.render = function () {
        var _this = this;
        var defaultColumns = [
            {
                title: 'Type / Subtype',
                dataIndex: 'typeAndSubtype',
                key: 'typeAndSubtype',
            },
            {
                title: 'Description',
                dataIndex: 'description',
                key: 'description',
            },
            {
                title: 'Start',
                dataIndex: 'start',
                key: 'start',
            },
            {
                title: 'End',
                dataIndex: 'end',
                key: 'end',
            },
        ];
        var _a = this.props, _b = _a.columns, columns = _b === void 0 ? defaultColumns : _b, _c = _a.assetEvents, assetEvents = _c === void 0 ? [] : _c, _d = _a.pagination, pagination = _d === void 0 ? { pageSize: 12 } : _d, scroll = _a.scroll, _e = _a.bordered, bordered = _e === void 0 ? false : _e, _f = _a.showHeader, showHeader = _f === void 0 ? true : _f, styles = _a.styles;
        var selectedEvent = this.state.selectedEvent;
        var _g = this.props.renderEventMetadata, renderEventMetadata = _g === void 0 ? defaultRenderEventMetadata : _g;
        return (React.createElement(React.Fragment, null,
            React.createElement(StyledTable, { key: "styleTable", columns: columns, dataSource: assetEvents.map(this.mapEvent), rowKey: "id", showHeader: showHeader, pagination: pagination, scroll: scroll, bordered: bordered, components: this.getTableComponents(), style: styles && styles.table }),
            !!selectedEvent && (React.createElement(Modal, { key: "Modal", visible: !!selectedEvent, footer: null, onCancel: function () { return _this.setState({ selectedEvent: null }); } }, !!selectedEvent && [
                this.renderEventDetails(selectedEvent),
                renderEventMetadata(selectedEvent),
            ]))));
    };
    AssetEventsPanelPureComponent.defaultProps = {
        theme: __assign({}, defaultTheme),
    };
    return AssetEventsPanelPureComponent;
}(React.Component));
var StyledTable = styled(Table)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledRow = styled.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: white;\n  cursor: pointer;\n  &:nth-child(2n) {\n    background: #fafafa;\n  }\n"], ["\n  background: white;\n  cursor: pointer;\n  &:nth-child(2n) {\n    background: #fafafa;\n  }\n"])));
var StyledCell = styled.td(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 500px;\n"], ["\n  max-width: 500px;\n"])));
var EventDetails = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  .description {\n    font-size: 18px;\n    padding-top: 16px;\n  }\n  .times {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 16px;\n  }\n"], ["\n  .description {\n    font-size: 18px;\n    padding-top: 16px;\n  }\n  .times {\n    display: flex;\n    justify-content: space-between;\n    padding-top: 16px;\n  }\n"])));
var EventMetadataList = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: 32px;\n  max-height: calc(100vh - 400px);\n  overflow: auto;\n  .event-metadata {\n    padding: 16px;\n    &:nth-child(2n) {\n      background: #fbfbfb;\n    }\n  }\n"], ["\n  margin-top: 32px;\n  max-height: calc(100vh - 400px);\n  overflow: auto;\n  .event-metadata {\n    padding: 16px;\n    &:nth-child(2n) {\n      background: #fbfbfb;\n    }\n  }\n"])));
var Component = withDefaultTheme(AssetEventsPanelPureComponent);
Component.displayName = 'AssetEventsPanelPure';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

// Copyright 2020 Cognite AS
var AssetEventsPanel = withAssetEvents(Component);

export { AssetEventsPanel };
